module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gray-back",
    staticStyle: {
      "padding": ".2rem 0 1rem 0"
    }
  }, [_c('van-cell-group', [_c('van-cell', {
    attrs: {
      "title": "省市",
      "value": _vm.row.county ? _vm.row.province + '/' + _vm.row.city + '/' + _vm.row.county : ''
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "title": "学校",
      "value": _vm.row.danwei
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "title": "参赛人数",
      "value": _vm.row.renshu
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "title": "联系人姓名",
      "value": _vm.row.name
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "title": "联系人手机",
      "value": _vm.row.phone
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "title": "联系人邮箱",
      "value": _vm.row.email
    }
  })], 1), _vm._v(" "), _c('van-divider', [_vm._v("校长信息")]), _vm._v(" "), _c('van-cell-group', [_c('van-cell', {
    attrs: {
      "title": "校长姓名",
      "value": _vm.row.xiaozhang_name
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "title": "校长身份证号",
      "value": _vm.row.xiaozhang_num
    }
  })], 1), _vm._v(" "), _c('van-divider', [_vm._v("教师信息(先进个人)")]), _vm._v(" "), _c('van-cell-group', [_c('van-cell', {
    attrs: {
      "title": "教师姓名",
      "value": _vm.row.jiaoshi_name
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "title": "教师身份证",
      "value": _vm.row.jiaoshi_num
    }
  })], 1), _vm._v(" "), _c('van-divider', [_vm._v("审核信息")]), _vm._v(" "), _c('van-cell', {
    attrs: {
      "title": "备案审核"
    }
  }, [(_vm.row.registstatus == 0) ? _c('div', [_vm._v("未提交")]) : (_vm.row.registstatus == 1) ? _c('div', [_vm._v("待审核")]) : (_vm.row.registstatus == 2) ? _c('div', [_vm._v("审核通过")]) : (_vm.row.registstatus == 3) ? _c('div', [_vm._v("审核失败")]) : _vm._e()]), _vm._v(" "), _c('van-cell', {
    attrs: {
      "title": "管理员备注",
      "value": _vm.row.adminnote
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5825cefd","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/weiyuanhui/apps/dakejian/DakejianDetail.vue
// module id = 2415
// module chunks = 0